<template>
  <section
      v-if="pageCount > 1"
      class="paginator"
  >
    <button @click="prevPage" class="paginator__button paginator__item" aria-label="prev">
      <AppIconLoader name="arrowRight" variant="small" aria-hidden="true" class="paginator__icon"/>
    </button>
    <span
        class="paginator__label paginator__item">{{
        state.currentPage
      }} / {{
        pageCount
      }}</span>
    <button @click="nextPage" class="paginator__button paginator__item" aria-label="next">
      <AppIconLoader name="arrowRight" variant="small" aria-hidden="true"/>
    </button>
  </section>
</template>

<script setup lang="ts">
import {computed, onUpdated, reactive} from "vue";
import {useRouter} from "nuxt/app";

const emit = defineEmits(['onPageChanged'])
const router = useRouter()

const props = defineProps<{
  itemCount: number,
  itemsPerPage: number,
  initialPage: number,
}>()

const state = reactive({
  currentPage: props.initialPage
})

onUpdated(() => {
  if (state.currentPage !== props.initialPage) {
    state.currentPage = props.initialPage
  }
})

const pageCount = computed(() => {
  return Math.ceil(props.itemCount / props.itemsPerPage)
})

const nextPage = () => {
  if (state.currentPage < pageCount.value) {
    state.currentPage += 1
    emit('onPageChanged', state.currentPage)
  }
}

const prevPage = () => {
  if (state.currentPage > 1) {
    state.currentPage -= 1
    emit('onPageChanged', state.currentPage)
  }
}
</script>

<style scoped lang="postcss">
.paginator {
  @mixin container;
  margin-bottom: 4rem;
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  @mixin app-container-padding;

  @media (--lg) {
    margin-top: 4rem;
  }

  &__button {
    background-color: var(--color-blue-aqua);
    color: var(--color-blue-prussian);
  }

  &__icon {
    transform: rotate(180deg);
  }

  &__label {
    user-select: none;
    background-color: var(--color-blue-prussian);
    font-family: Midnight, sans-serif;
    font-size: 28px;
    text-transform: uppercase;
    line-height: 0.9;
    color: var(--color-blue-aqua);
  }

  &__item {
    display: flex;
    height: 2.5rem;
    align-items: center;
    border-radius: 20px;
    border-width: 1px;
    border-color: var(--color-blue-aqua);
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background-color: var(--color-blue-prussian);
      color: var(--color-blue-aqua);
    }
  }
}
</style>
